"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ChatNugget = _interopRequireDefault(require("./nuggets/ChatNugget"));

var _ErvAlertsNugget = _interopRequireDefault(require("./nuggets/ErvAlertsNugget"));

var _ErvIAmSafeNugget = _interopRequireDefault(require("./nuggets/ErvIAmSafeNugget"));

var _ErvCountryInfoNugget = _interopRequireDefault(require("./nuggets/ErvCountryInfoNugget"));

var _ErvEmergencyNugget = _interopRequireDefault(require("./nuggets/ErvEmergencyNugget"));

var _ErvDocumentsSafeNugget = _interopRequireDefault(require("./nuggets/ErvDocumentsSafeNugget"));

var _ErvCurrencyConverter = _interopRequireDefault(require("./nuggets/ErvCurrencyConverter"));

var _ErvWarRiskNugget = _interopRequireDefault(require("./nuggets/ErvWarRiskNugget"));

var _HtmlNugget = _interopRequireDefault(require("./nuggets/HtmlNugget"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../helpers/CordovaFileHelper"));

var _Lecture = _interopRequireWildcard(require("./Lecture"));

var _Spoc = _interopRequireWildcard(require("./Spoc"));

var _Course = _interopRequireWildcard(require("./Course"));

var _Nugget = require("./Nugget");

var _Rubric = _interopRequireWildcard(require("./Rubric"));

var _EventSeries = _interopRequireWildcard(require("./EventSeries"));

var _EventDate = _interopRequireWildcard(require("./EventDate"));

var _Docent = _interopRequireWildcard(require("./Docent"));

var _Venue = _interopRequireWildcard(require("./Venue"));

var _NewsBlock = _interopRequireWildcard(require("./NewsBlock"));

var _MazarsCertNugget = _interopRequireDefault(require("./nuggets/MazarsCertNugget"));

var _VideoNugget = _interopRequireDefault(require("./nuggets/VideoNugget"));

var _VideoUploadNugget = _interopRequireDefault(require("./nuggets/VideoUploadNugget"));

var _UrlNugget = _interopRequireDefault(require("./nuggets/UrlNugget"));

var _VoteNugget = _interopRequireDefault(require("./nuggets/VoteNugget"));

var _FlipNugget = _interopRequireDefault(require("./nuggets/FlipNugget"));

var _FormNugget = _interopRequireDefault(require("./nuggets/FormNugget"));

var _QuizNugget = _interopRequireDefault(require("./nuggets/QuizNugget"));

var _SwipeNugget = _interopRequireDefault(require("./nuggets/SwipeNugget"));

var _WizardNugget = _interopRequireDefault(require("./nuggets/WizardNugget"));

var _QdNugget = _interopRequireDefault(require("./nuggets/QdNugget"));

var _ErvCorporateNugget = _interopRequireDefault(require("./nuggets/ErvCorporateNugget"));

var _QDQuestionEditorNugget = _interopRequireDefault(require("./nuggets/QDQuestionEditorNugget"));

var _ErgoCalculatorNugget = _interopRequireDefault(require("./nuggets/ErgoCalculatorNugget"));

var _ErgoStructureNugget = _interopRequireDefault(require("./nuggets/ErgoStructureNugget"));

var _ErgoRequestCodeNugget = _interopRequireDefault(require("./nuggets/ErgoRequestCodeNugget"));

var _ErgoStructureRankingNugget = _interopRequireDefault(require("./nuggets/ErgoStructureRankingNugget"));

var _ErgoGlobalRankingNugget = _interopRequireDefault(require("./nuggets/ErgoGlobalRankingNugget"));

var _ErgoActivityNugget = _interopRequireDefault(require("./nuggets/ErgoActivityNugget"));

var _ErgoRulesNugget = _interopRequireDefault(require("./nuggets/ErgoRulesNugget"));

var _PDFNugget = _interopRequireDefault(require("./nuggets/PDFNugget"));

var _ListNugget = _interopRequireDefault(require("./nuggets/ListNugget"));

var _TerminNugget = _interopRequireDefault(require("./nuggets/TerminNugget"));

var _GalleryNugget = _interopRequireDefault(require("./nuggets/GalleryNugget"));

var _EventSeriesNugget = _interopRequireDefault(require("./nuggets/EventSeriesNugget"));

var _RubricNugget = _interopRequireDefault(require("./nuggets/RubricNugget"));

var _QRReaderNugget = _interopRequireDefault(require("./nuggets/QRReaderNugget"));

var _FeedbackNugget = _interopRequireDefault(require("./nuggets/FeedbackNugget"));

var _LiveTickerNugget = _interopRequireDefault(require("./nuggets/LiveTickerNugget"));

var _FeedbackContainerNugget = _interopRequireDefault(require("./nuggets/FeedbackContainerNugget"));

var _EkgNugget = _interopRequireDefault(require("./nuggets/EkgNugget"));

var _LikertNugget = _interopRequireDefault(require("./nuggets/LikertNugget"));

var _PodcastNugget = _interopRequireDefault(require("./nuggets/PodcastNugget"));

var _LikertResultNugget = _interopRequireDefault(require("./nuggets/LikertResultNugget"));

var _SelfReflectNugget = _interopRequireDefault(require("./nuggets/SelfReflectNugget"));

var _EPRFormNugget = _interopRequireDefault(require("./nuggets/EPRFormNugget"));

var _ReminderNugget = _interopRequireDefault(require("./nuggets/ReminderNugget"));

var _DataStoreNugget = _interopRequireDefault(require("./nuggets/DataStoreNugget"));

var _ContainerNugget = _interopRequireDefault(require("./nuggets/ContainerNugget"));

var _VideoPlaylistNugget = _interopRequireDefault(require("./nuggets/VideoPlaylistNugget"));

var _EventDateNugget = _interopRequireDefault(require("./nuggets/EventDateNugget"));

var _LivestreamNugget = _interopRequireDefault(require("./nuggets/LivestreamNugget"));

var _ErgoCandidateListNugget = _interopRequireDefault(require("./nuggets/ErgoCandidateListNugget"));

var _ErvAirDoctorsNugget = _interopRequireDefault(require("./nuggets/ErvAirDoctorsNugget"));

var _ErgoChatNugget = _interopRequireDefault(require("./nuggets/ErgoChatNugget"));

var _ErgoSingleCandidateNugget = _interopRequireDefault(require("./nuggets/ErgoSingleCandidateNugget"));

var _ErgoAddCandidateNugget = _interopRequireDefault(require("./nuggets/ErgoAddCandidateNugget"));

var _ErgoRecruiterQRCodeNugget = _interopRequireDefault(require("./nuggets/ErgoRecruiterQRCodeNugget"));

var _ErvA3mNugget = _interopRequireDefault(require("./nuggets/ErvA3mNugget"));

var _ErgoProRecruitingCandidateNugget = _interopRequireDefault(require("./nuggets/ErgoProRecruitingCandidateNugget"));

var _FFBNugget = _interopRequireDefault(require("./nuggets/FFBNugget"));

var _FFBFeedbackNugget = _interopRequireDefault(require("./nuggets/FFBFeedbackNugget"));

var ContentParser = /*#__PURE__*/function () {
  function ContentParser() {
    (0, _classCallCheck2["default"])(this, ContentParser);
  }

  (0, _createClass2["default"])(ContentParser, null, [{
    key: "parseFromFile",

    /**
     *
     * @param filenameAndMd5
     * @param foldername
     * @param fileEntry
     * @returns {Promise.<ContentEntity>}
     */
    value: function () {
      var _parseFromFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(filenameAndMd5) {
        var foldername,
            fileText,
            json,
            entity,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                foldername = _args.length > 1 && _args[1] !== undefined ? _args[1] : _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER;
                _context.prev = 1;

                // console.log(`parsing content from file ${filenameAndMd5.filename} - checkMd5: ${filenameAndMd5.checkMd5} - md5: ${filenameAndMd5.md5}`)
                if (filenameAndMd5 && !filenameAndMd5.filename) {
                  _promise["default"].resolve();
                }

                _context.next = 5;
                return _CordovaFileHelper["default"].readTextFile(filenameAndMd5.filename, foldername, filenameAndMd5.checkMd5 ? filenameAndMd5.md5 : null, filenameAndMd5.fileEntry ? filenameAndMd5.fileEntry : null);

              case 5:
                fileText = _context.sent;
                json = JSON.parse(fileText);
                json.md5 = filenameAndMd5.md5;
                entity = ContentParser.parse(json);

                if (entity) {
                  entity.filename = filenameAndMd5.filename;
                }

                return _context.abrupt("return", _promise["default"].resolve(entity));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13]]);
      }));

      function parseFromFile(_x) {
        return _parseFromFile.apply(this, arguments);
      }

      return parseFromFile;
    }()
  }, {
    key: "parseFromData",
    value: function () {
      var _parseFromData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(data) {
        var json, entity;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                // no known md5 if shown in browser (this function is called when opened in browser
                json = JSON.parse(data);
                entity = ContentParser.parse(json);

                if (entity) {
                  entity.filename = "".concat(json.id, ".json");
                }

                return _context2.abrupt("return", _promise["default"].resolve(entity));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      function parseFromData(_x2) {
        return _parseFromData.apply(this, arguments);
      }

      return parseFromData;
    }()
    /**
     *
     * @param json
     * @returns {ContentEntity}
     */

  }, {
    key: "parse",
    value: function parse(json) {
      if (json && json.type) {
        if (json.type === _Course.TYPE) {
          return new _Course["default"](json);
        }

        if (json.type === _NewsBlock.TYPE) {
          return new _NewsBlock["default"](json);
        }

        if (json.type === _Spoc.TYPE) {
          return new _Spoc["default"](json);
        }

        if (json.type === _Lecture.TYPE) {
          return new _Lecture["default"](json);
        } // nuggets have a special static method for parsing


        if (json.type === _Nugget.TYPE) {
          return ContentParser.parseNugget(json);
        }

        if (json.type === _Rubric.TYPE) {
          return new _Rubric["default"](json);
        }

        if (json.type === _EventSeries.TYPE) {
          return new _EventSeries["default"](json);
        }

        if (json.type === _EventDate.TYPE) {
          return new _EventDate["default"](json);
        }

        if (json.type === _Venue.TYPE) {
          return new _Venue["default"](json);
        }

        if (json.type === _Docent.TYPE) {
          return new _Docent["default"](json);
        }

        console.warn("not parsing json as content entity due to unknown type '".concat(json.type, "'."), json);
      }

      return null;
    }
  }, {
    key: "parseNugget",
    value: function parseNugget(json) {
      if (json && json["class"]) {
        if (json["class"] === _ChatNugget["default"].CLASS) {
          return new _ChatNugget["default"](json);
        }

        if (json["class"] === _ErgoChatNugget["default"].CLASS) {
          return new _ErgoChatNugget["default"](json);
        }

        if (json["class"] === _ErvAlertsNugget["default"].CLASS) {
          return new _ErvAlertsNugget["default"](json);
        }

        if (json["class"] === _ErvIAmSafeNugget["default"].CLASS) {
          return new _ErvIAmSafeNugget["default"](json);
        }

        if (json["class"] === _ErvCountryInfoNugget["default"].CLASS) {
          return new _ErvCountryInfoNugget["default"](json);
        }

        if (json["class"] === _ErvEmergencyNugget["default"].CLASS) {
          return new _ErvEmergencyNugget["default"](json);
        }

        if (json["class"] === _ErvDocumentsSafeNugget["default"].CLASS) {
          return new _ErvDocumentsSafeNugget["default"](json);
        }

        if (json["class"] === _ErvCurrencyConverter["default"].CLASS) {
          return new _ErvCurrencyConverter["default"](json);
        }

        if (json["class"] === _ErvWarRiskNugget["default"].CLASS) {
          return new _ErvWarRiskNugget["default"](json);
        }

        if (json["class"] === _ErvAirDoctorsNugget["default"].CLASS) {
          return new _ErvAirDoctorsNugget["default"](json);
        }

        if (json["class"] === _ErvA3mNugget["default"].CLASS) {
          return new _ErvA3mNugget["default"](json);
        }

        if (json["class"] === _ErvCorporateNugget["default"].CLASS) {
          return new _ErvCorporateNugget["default"](json);
        }

        if (json["class"] === _HtmlNugget["default"].CLASS) {
          return new _HtmlNugget["default"](json);
        }

        if (json["class"] === _PodcastNugget["default"].CLASS) {
          return new _PodcastNugget["default"](json);
        }

        if (json["class"] === _VideoPlaylistNugget["default"].CLASS) {
          return new _VideoPlaylistNugget["default"](json);
        }

        if (json["class"] === _LikertNugget["default"].CLASS) {
          return new _LikertNugget["default"](json);
        }

        if (json["class"] === _LikertResultNugget["default"].CLASS) {
          return new _LikertResultNugget["default"](json);
        }

        if (json["class"] === _VideoNugget["default"].CLASS) {
          return new _VideoNugget["default"](json);
        }

        if (json["class"] === _VideoUploadNugget["default"].CLASS) {
          return new _VideoUploadNugget["default"](json);
        }

        if (json["class"] === _UrlNugget["default"].CLASS) {
          return new _UrlNugget["default"](json);
        }

        if (json["class"] === _QDQuestionEditorNugget["default"].CLASS) {
          return new _QDQuestionEditorNugget["default"](json);
        }

        if (json["class"] === _VoteNugget["default"].CLASS) {
          return new _VoteNugget["default"](json);
        }

        if (json["class"] === _FlipNugget["default"].CLASS) {
          return new _FlipNugget["default"](json);
        }

        if (json["class"] === _QuizNugget["default"].CLASS) {
          return new _QuizNugget["default"](json);
        }

        if (json["class"] === _SwipeNugget["default"].CLASS) {
          return new _SwipeNugget["default"](json);
        }

        if (json["class"] === _WizardNugget["default"].CLASS) {
          return new _WizardNugget["default"](json);
        }

        if (json["class"] === _ListNugget["default"].CLASS) {
          return new _ListNugget["default"](json);
        }

        if (json["class"] === _QdNugget["default"].CLASS) {
          return new _QdNugget["default"](json);
        }

        if (json["class"] === _FormNugget["default"].CLASS) {
          return new _FormNugget["default"](json);
        }

        if (json["class"] === _EPRFormNugget["default"].CLASS) {
          return new _EPRFormNugget["default"](json);
        }

        if (json["class"] === _ReminderNugget["default"].CLASS) {
          return new _ReminderNugget["default"](json);
        }

        if (json["class"] === _DataStoreNugget["default"].CLASS) {
          return new _DataStoreNugget["default"](json);
        }

        if (json["class"] === _PDFNugget["default"].CLASS) {
          return new _PDFNugget["default"](json);
        }

        if (json["class"] === _ErgoCalculatorNugget["default"].CLASS) {
          return new _ErgoCalculatorNugget["default"](json);
        }

        if (json["class"] === _ErgoStructureNugget["default"].CLASS) {
          return new _ErgoStructureNugget["default"](json);
        }

        if (json["class"] === _ErgoStructureRankingNugget["default"].CLASS) {
          return new _ErgoStructureRankingNugget["default"](json);
        }

        if (json["class"] === _ErgoGlobalRankingNugget["default"].CLASS) {
          return new _ErgoGlobalRankingNugget["default"](json);
        }

        if (json["class"] === _ErgoActivityNugget["default"].CLASS) {
          return new _ErgoActivityNugget["default"](json);
        }

        if (json["class"] === _ErgoRequestCodeNugget["default"].CLASS) {
          return new _ErgoRequestCodeNugget["default"](json);
        }

        if (json["class"] === _ErgoRulesNugget["default"].CLASS) {
          return new _ErgoRulesNugget["default"](json);
        }

        if (json["class"] === _TerminNugget["default"].CLASS) {
          return new _TerminNugget["default"](json);
        }

        if (json["class"] === _GalleryNugget["default"].CLASS) {
          return new _GalleryNugget["default"](json);
        }

        if (json["class"] === _EventSeriesNugget["default"].CLASS) {
          return new _EventSeriesNugget["default"](json);
        }

        if (json["class"] === _EventDateNugget["default"].CLASS) {
          return new _EventDateNugget["default"](json);
        }

        if (json["class"] === _RubricNugget["default"].CLASS) {
          return new _RubricNugget["default"](json);
        }

        if (json["class"] === _QRReaderNugget["default"].CLASS) {
          return new _QRReaderNugget["default"](json);
        }

        if (json["class"] === _MazarsCertNugget["default"].CLASS) {
          return new _MazarsCertNugget["default"](json);
        }

        if (json["class"] === _LiveTickerNugget["default"].CLASS) {
          return new _LiveTickerNugget["default"](json);
        }

        if (json["class"] === _LivestreamNugget["default"].CLASS) {
          return new _LivestreamNugget["default"](json);
        }

        if (json["class"] === _FeedbackNugget["default"].CLASS) {
          return new _FeedbackNugget["default"](json);
        }

        if (json["class"] === _FeedbackContainerNugget["default"].CLASS) {
          return new _FeedbackContainerNugget["default"](json);
        }

        if (json["class"] === _EkgNugget["default"].CLASS) {
          return new _EkgNugget["default"](json);
        }

        if (json["class"] === _SelfReflectNugget["default"].CLASS) {
          return new _SelfReflectNugget["default"](json);
        }

        if (json["class"] === _ContainerNugget["default"].CLASS) {
          return new _ContainerNugget["default"](json);
        }

        if (json["class"] === _ErgoCandidateListNugget["default"].CLASS) {
          return new _ErgoCandidateListNugget["default"](json);
        }

        if (json["class"] === _ErgoSingleCandidateNugget["default"].CLASS) {
          return new _ErgoSingleCandidateNugget["default"](json);
        }

        if (json["class"] === _ErgoAddCandidateNugget["default"].CLASS) {
          return new _ErgoAddCandidateNugget["default"](json);
        }

        if (json["class"] === _ErgoRecruiterQRCodeNugget["default"].CLASS) {
          return new _ErgoRecruiterQRCodeNugget["default"](json);
        }

        if (json["class"] === _ErgoProRecruitingCandidateNugget["default"].CLASS) {
          return new _ErgoProRecruitingCandidateNugget["default"](json);
        }

        if (json["class"] === _FFBNugget["default"].CLASS) {
          return new _FFBNugget["default"](json);
        }

        if (json["class"] === _FFBFeedbackNugget["default"].CLASS) {
          return new _FFBFeedbackNugget["default"](json);
        } else {
          console.warn("ignoring nugget with unknown class ".concat(json["class"]));
        }
      } else {
        console.warn('ignoring nugget without class');
      }

      return null;
    }
  }]);
  return ContentParser;
}();

var _default = ContentParser;
exports["default"] = _default;